import { render, staticRenderFns } from "./ModalCheckProofTransfer.vue?vue&type=template&id=0673e65c&scoped=true&"
import script from "./ModalCheckProofTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalCheckProofTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ModalCheckProofTransfer.vue?vue&type=style&index=0&id=0673e65c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673e65c",
  null
  
)

export default component.exports